import { ShortCode } from '@highereducation/wordpress';

type ExpertBoxExpertShortcodeProps = {
  name?: string;
  role?: string;
  'avatar-src'?: string;
  'avatar-fallback'?: string;
  href?: string;
  [key: string]: unknown;
};

/**
 * ExpertBoxExpertShortcode - Expert item for ExpertBox. Use inside [hen-ui-expert-box].
 * Renders nothing on its own; props are collected by the parent ExpertBoxShortcode.
 */
export const ExpertBoxExpertShortcode: ShortCode<ExpertBoxExpertShortcodeProps> =
  {
    component: () => null,
  };
